<app-header [forceLightBackground]="true"></app-header>
<div class="org-admin-add-dataset-new">
  <div class="org-admin-add-dataset-new--layout">
    <app-org-admin-sidebar class="org-admin-add-dataset-new--sidebar"></app-org-admin-sidebar>
    <div class="org-admin-add-dataset-new--content">
    <div class="org-admin-add-dataset-new--body">
      <app-page-header [showDivider]="false"></app-page-header>
    </div>
    <hr class="org-admin-add-dataset-new--title-divider" />
    <div class="org-admin-add-dataset-new--body">
      <div class="page-container">
          <lib-onboarding-home
            publisherRole="org-admin"
            (submitError)="onSubmitError($event)"
            (submitSuccess)="onSubmitSuccess($event)"
          />
        </div>
      </div>
    </div>
  </div>
</div>
